export default{
    'request.auth.error.refresh': 'Refreshed access token, Please retry.',
    'request.comm.error.no.response': 'None response, Please retry.',
    'request.comm.error.request.fail': 'Request error, please retry.',
    'request.comm.error.fail': 'Telecom error, please retry.',

    'request.comm.error.a0000e0001': 'Token has expired. Please log in again.',
    'request.comm.error.a0000e0002': 'This account is disabled.',
    'request.comm.error.a0000e0003': 'Invalid request parameters.',
    'request.comm.error.a0000e9999': 'If the issue persists, please contact your system administrator.',
    'request.comm.error.a0101e0001': 'Login failed.',
    'request.comm.error.a0103e0001': 'Token has expired. Please log in again.',
    'request.comm.error.a0302e0001': 'Error occurred. Please contact your system administrator if this continues.',
    'request.comm.error.a0303e0001': 'Registration failed. The user ID is already registered.',
    'request.comm.error.a0303e9999': 'Error occurred. Please contact your system administrator if this continues.',
    'request.comm.error.a0304e0001': 'Update failed. The user ID is already registered.',
    'request.comm.error.a0305e0001': 'Delete failed. The user ID is already registered.',
    'request.comm.error.a0402e0001': 'Failed to retrieve data. The specified customer ID does not exist.',
    'request.comm.error.a0403e0001': 'Failed to register. The customer ID is already registered.',
    'request.comm.error.a0403e9999': 'An error has occurred. If the problem persists, please contact the system administrator.',
    'request.comm.error.a0404e0001': 'Failed to update. The specified customer ID does not exist.',
    'request.comm.error.a0405e0001': 'Failed to delete. The specified customer ID does not exist.',
};
